import { nullishToOptional } from "../helpers";
import { CardSchema } from "./card";
import { BillingIntervalSchema } from "./price";
import { ProductCodeSchema } from "./product";
import { z } from "zod";
export const StripeSubscriptionStatusSchema = z.enum([
    "trialing",
    "active",
    "past_due",
    "canceled",
    "unpaid",
    "incomplete_expired",
    "incomplete",
    "unknown",
]);
export const InternalStatusSchema = z.enum([
    "active",
    "suspended",
    "gracePeriod",
    "cancelled",
    "downgraded_to_free",
]);
export const BillingTypeSchema = z.enum(["Auto", "Invoice"]);
export const StripeSubscriptionStatus = StripeSubscriptionStatusSchema.enum;
export const InternalStatus = InternalStatusSchema.enum;
export const BillingType = BillingTypeSchema.enum;
export const Subscription = z.object({
    card: nullishToOptional(CardSchema),
    seats: z.number(),
    seatLimit: z.number(),
    monthlyCreditGrantAnchor: nullishToOptional(z.string()),
    monthlyCreditGrantAmount: nullishToOptional(z.number()),
    builderSeatLimit: nullishToOptional(z.number()),
    fullSeatLimit: nullishToOptional(z.number()),
    additionalCredits: nullishToOptional(z.number()),
    builderSeats: nullishToOptional(z.number()),
    fullSeats: nullishToOptional(z.number()),
    status: nullishToOptional(InternalStatusSchema),
    subscriptionStatus: nullishToOptional(StripeSubscriptionStatusSchema),
    internalStatus: nullishToOptional(InternalStatusSchema),
    stripeSubscriptionId: nullishToOptional(z.string()),
    stripeCustomerId: nullishToOptional(z.string()),
    stripeScheduleId: nullishToOptional(z.string()),
    product: ProductCodeSchema,
    planPriceId: z.string(),
    planInterval: BillingIntervalSchema,
    currentPeriodStart: nullishToOptional(z.string()),
    currentPeriodEnd: nullishToOptional(z.string()),
    cancelAt: nullishToOptional(z.string()),
    fullSeatPriceId: nullishToOptional(z.string()),
    builderSeatPriceId: nullishToOptional(z.string()),
    additionalCreditsPriceId: nullishToOptional(z.string()),
    subscriptionStatusUpdatedAt: nullishToOptional(z.string()),
});
